export default "https://cdn-static.gokick.com/assets/1d764bbda6f1db3d5ed96a1ece7edd078534d524/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";